var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighDefinition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19,2H5C2.243,2,0,4.243,0,7v10c0,2.757,2.243,5,5,5h14c2.757,0,5-2.243,5-5V7c0-2.757-2.243-5-5-5Zm3,15c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V7c0-1.654,1.346-3,3-3h14c1.654,0,3,1.346,3,3v10Zm-11-9v8c0,.552-.448,1-1,1s-1-.448-1-1v-3h-3v3c0,.552-.448,1-1,1s-1-.448-1-1v-8c0-.552.448-1,1-1s1,.448,1,1v3h3v-3c0-.552.448-1,1-1s1,.448,1,1Zm5-1h-1c-1.103,0-2,.897-2,2v6c0,1.103.897,2,2,2h1c2.206,0,4-1.794,4-4v-2c0-2.206-1.794-4-4-4Zm2,6c0,1.103-.897,2-2,2h-1s0-6,0-6h1c1.103,0,2,.897,2,2v2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighDefinition);
export default __webpack_public_path__ + "static/media/high-definition.1162567c091e5eb7912b5b5ac6f12972.svg";
export { ForwardRef as ReactComponent };